import request from '@/shared/api/request';

export const attachFirewallToStacklet = (
  uuid: string,
  data: { stacklet_ids: number[] },
): Promise<void> =>
  request({
    url: `/firewalls/${uuid}/stacklets/`,
    method: 'POST',
    data,
  });
